<div class="contentblock">
  <h3>Requested</h3>

  <div *ngIf="item.type == 'SUCCESSFACTOR'">
    <div
      class="form-group row"
      *ngFor="let subindicator of ['E', 'I', 'P', 'C']"
    >
      <label for="label" class="col-sm-2 col-form-label">{{
        subindicator
      }}</label>
      <div class="col-sm-10">
        <kendo-switch
          name="requested"
          [(ngModel)]="item.requested[subindicator]"
          (valueChange)="onChangeSuccessfactor(subindicator)"
        ></kendo-switch>
      </div>
    </div>
  </div>

  <div *ngIf="item.type == 'INDICATOR'">
    <div
      class="form-group row"
      *ngFor="let subindicator of ['E', 'I', 'P', 'C']"
    >
      <label for="label" class="col-sm-2 col-form-label">{{
        subindicator
      }}</label>
      <div class="col-sm-10">
        <kendo-switch
          name="requested"
          [(ngModel)]="item.requested[subindicator]"
          (valueChange)="onChangeRequested()"
        ></kendo-switch>
      </div>
    </div>
  </div>

  <div *ngIf="item.type == 'QUESTION'">
    <div class="form-group row">
      <label for="label" class="col-sm-2 col-form-label">Requested</label>
      <div class="col-sm-10">
        <kendo-switch
          name="requested"
          [(ngModel)]="item.requested"
          (valueChange)="onChangeRequested()"
        ></kendo-switch>
      </div>
    </div>
  </div>
</div>
